/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Slider, Typography } from '@material-ui/core'
import ChipInput from 'material-ui-chip-input'
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
const styles = theme => ({

})

class FlexSlider extends Component {
    state = {
        value : null,
        error : false,
        helper_text : "",
        slider_type: null,
        min_value: null,
        max_value: null,
        step_size: null,
        valueLabelDisplay: null,
        marks: []

    }

    componentWillMount () {
        console.log("Type: ", this.props.instance.component)
        console.log("ID: ", this.props.instance.id)
        this.setState({...this.state, value : this.props.instance.value.number }, () => { this.setErrorAndHelperText(); this.setSliderDefaults(); })
    }

    getParam = (param_name, value_type) => {
        let parameter = null

        if (this.props.instance.component_params !== null) {
            this.props.instance.component_params.map(param => {
                if (param.name === param_name) {
                    parameter = param.value[value_type]
                }
            })
        }

        return parameter
    }

    setSliderDefaults = () => {
       // let slider_type = this.getParam("slider_type", "text")
        let min_value = this.getParam("min_value", "number")
        let max_value = this.getParam("max_value", "number")
        let step_size = this.getParam("step_size", "number")
       // let valueLabelDisplay = this.getParam("valueLabelDisplay", "text")

        this.setState({...this.state,
            min_value, max_value, step_size,
            marks: [
                {
                    value: min_value,
                    label:  min_value
                },
                {
                    value: max_value,
                    label: max_value
                }
            ]
        })

    }

    setErrorAndHelperText = () => {
        let config_error = this.getParam("error", "boolean")
        let helper_text = this.getParam("helper_text", "text")
        let error_message = this.getParam("error_message", "text") !== null ? this.getParam("error_message", "text") : this.getParam("helper_text", "text")

        if (config_error !== null) {
            this.setState({...this.state, 
                error : config_error, 
                helper_text : config_error === true ? error_message : helper_text
            })
        } else {
            this.setState({
                ...this.state,
                helper_text : helper_text
            })
        }
    }

    getErrorAndHelperText = () => {
        let state_error = this.state.error

        if (state_error === true) {
            this.setState({...this.state, error : true}, () => this.getHelperText())
        }
    }

    getHelperText = () => {
        let helper_text
        if (this.state.error === false) {
            helper_text = this.getParam("helper_text", "text")
        } else {
            helper_text = "Invalid entry"
        }

        this.setState({...this.state, helper_text : helper_text})
    }

    handleChange = (event, newValue) => {
        this.setState({ ...this.state, value: newValue }, () => this.props.update_value(this.props.instance.id, "number", this.state.value))
    }

    getValueType = (component) => {
        switch (component) {
            case "text" :
                return "text"
            
            case "number" :
                return "number"

            case "email" :
                return "text"

            case "password" :
                return "text"

            case "url" :
                return "text"

            default:
                return "text"
        }
    }

    validateAndPush = () => {
        console.log('Validating! ', this.props.instance.id)
        if (this.validate(this.props.instance.component)) {
            this.setState({...this.state, error : false}, () => {
                this.getHelperText()
                this.props.update_value(this.props.instance.id, "number", this.state.value)
            })
        } else {
            this.setState({...this.state, error : true}, () => {
                this.getHelperText()
            })
        }
    }

    validate = (validation_type) => {
        switch (validation_type) {
            case "email":
                return this.validateEmail()
            
            // case "url" :
            //     return this.validateUrl()
            
            default:
                return true
        }
    }

    render() {
        const { classes } = this.props
        return (
            <div style = {{width : '100%', paddingLeft : '10px', paddingRight : '10px'}}>
                <Typography gutterBottom = {false} variant = 'body2'>{ this.props.instance.name }</Typography>
                <FormControl 
                    style = {{width : '100%'}}
                    error = {this.state.error}
                    disabled = {this.props.disabled}
                >
                    <Slider  
                        style={{
                            width: "100%",
                        }}
                        aria-labelledby={"continuous-slider"} 
                        value={this.state.value}
                        min={this.state.min_value !== null ? this.state.min_value : 0 }
                        max={this.state.max_value}
                        step = {this.state.step_size}
                        marks={this.state.marks}
                        valueLabelDisplay="auto"
                        onChange = { (event, value) => this.handleChange(event, value)}
                    />
                    <FormHelperText>{this.state.helper_text}</FormHelperText>
                </FormControl>
            </div>
        );
    }
}

export default withStyles(styles)(FlexSlider)